<template>
  <!-- 职级及利益组成 -->
  <div>
    <div class="tools-box">
      <div class="left-box">{{ baseInfo.name }}</div>
      <div class="right-box">
        <Button type="primary" @click="$refs.addRankCommissions.open(baseInfo, tableData)">添加费用项</Button>
      </div>
    </div>
    <div class="page-body">
      <Menu ref="menuRef" theme="light" :active-name="rankId" @on-select="rankChange">
        <MenuItem v-for="bean in rankList" :key="bean.id" :name="bean.id">{{bean.name}}</MenuItem>
      </Menu>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" draggable @on-drag-drop="drag">
          <template slot-scope="{ row }" slot="ruleName">
            <Tooltip :disabled="row.hideTooltip">
              <div v-html="row.ruleName" class="rule-name"></div>
              <div v-if="!row.hideTooltip">...</div>
              <div slot="content" v-html="row.ruleName"></div>
            </Tooltip>
            
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn drage"></span>
            <span class="table-btn delete" @click="del(row)"></span>
          </template>
        </Table>
      </div>
    </div>
    
    <div class="tools-box right bottom-box">
      <Button type="primary" @click="$emit('prev')">上一步</Button>
      <Button type="primary" @click="$emit('next')">下一步</Button>
    </div>

    <!-- 新增费用项 -->
    <add-rank-commissions ref="addRankCommissions" :rankId="rankId" :pageData="pageData" @reload="getTabelData"></add-rank-commissions>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import addRankCommissions from './addRankCommissions';
import confirmModal from '@/components/commons/confirmModal'
export default {
  mixins: [common],
  components: { addRankCommissions, confirmModal },
  data() {
    return {
      baseInfo: {},
      pageData:{},
      rankId: "",//当前选择的职级id
      rankList:[],//职级列表
      listLoading: false,
      columns: [
        {
          title: '序号',
          width: 80,
          type: 'index',
          align: 'center'
        },
        {
          title: '费用项名称',
          key: 'name',
          minWidth: 140,
          tooltip:true,
          align: 'center'
        },
        {
          title: '费用项计算公式',
          slot: 'ruleName',
          tooltip:true,
          minWidth: 300,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 110
        }
      ],
      tableData: []
    };
  },
  methods: {
    init(baseInfo) {
      this.baseInfo = baseInfo;
      this.getRankList();
    },
    // 获取职级列表
    getRankList(){
      this.$http({
        url: '/buz/baseRank/read/all',
        type: 'POST',
        data: {}
      }).then(res => {
        this.rankList = res.data;
        if(res.data[0]) {
          this.rankId = res.data[0].id;
          this.$nextTick(()=>{
            this.$refs.menuRef.updateActiveName();
          })
          this.getTabelData()
        }
      });
    },
    // 切换职级
    rankChange(rankId){
      this.rankId = rankId;
      this.getTabelData()
    },
    getTabelData(){
      this.$http({
        url: '/buz/baseCommissionJoin/commissions',
        type: 'POST',
        data: {
          baseId: this.baseInfo.id,
          rankId: this.rankId,
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        if(res.data && res.data.baseCommissions){
          this.pageData = res.data;
          this.tableData = res.data.baseCommissions;
        }else{
          this.tableData = [];
          this.pageData = {};
        }
        this.$nextTick(()=>{
          this.setTableStyle();
        })
      });
    },
    // 根据内容高度设置表格
    setTableStyle(){
      const arr = document.getElementsByClassName('rule-name')
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if(element.clientHeight == 20) {
          this.$set(this.tableData[i], 'hideTooltip', true);
        }else{
          this.$set(this.tableData[i], 'hideTooltip', false);
          element.style.height = "20px";
        }
      }
    },
    del(bean){
      this.$refs.confirmModal.open({
        title: "提示",
        content: "确定删除费用项？",
      }).then(() => {
        const ids = this.tableData.map(item=>item.id).filter(id=>id != bean.id)
        this.$http({
          url: '/buz/baseCommissionJoin/edit',
          type: 'POST',
          data: {
            id: this.pageData.id,
            baseId: this.baseInfo.id,
            rankId: this.rankId,
            selected: ids,
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getTabelData();
        })
      }).catch(() => {
        
      });
    },
    drag(index1, index2){
      console.log(index1, index2)
      this.tableData.splice(index2, 0, this.tableData.splice(index1,1)[0]);
      const sortRule = {};
      this.tableData.forEach((item,i)=>{
        sortRule[item.id] = i+1;
      })
      const ids = this.tableData.map(item=>item.id)
      this.$http({
        url: '/buz/baseCommissionJoin/edit',
        type: 'POST',
        data: {
          id: this.pageData.id,
          baseId: this.baseInfo.id,
          rankId: this.rankId,
          sortRule: JSON.stringify(sortRule),
          selected: ids,
        }
      }).then(res => {
        this.$notice.success('操作成功');
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.page-body {
  display: flex;
}
.ivu-menu {
  min-width: 120px;
  margin-right: 15px;
}
.table-btn {
  vertical-align: middle;
  &.drage {
    background: url(~@static/images/product/drage.png) no-repeat;
    width: 14px;
    height: 14px;
  }
  &.delete {
    background: url(~@static/images/product/delete.png) no-repeat;
    width: 14px;
    height: 14px;
  }
}
.rule-name {
  // height: 20px;
  overflow: hidden;
}
.ivu-tooltip {
  width: 100%;
  display: block;
  /deep/ .ivu-tooltip-rel {
    display: block;
  }
}
</style>
